import { Button, IconButton, Menu, MenuItem } from '@material-ui/core';
import { useStyles } from './LogoutButton.styles';
import {useMsal, useIsAuthenticated } from '@azure/msal-react';
import { getAppConfiguration } from '../../../../Config';
import {FormattedMessage, useIntl} from 'react-intl';
import { Hidden } from '@mui/material';
import { AccountCircle } from '@material-ui/icons';
import React from 'react';
import { getAuthProvider } from "../../../../Auth/authProvider";
export const LogoutBUtton =()=>{
    const{instance} = useMsal();
    const classes = useStyles();
    const accounts = instance.getAllAccounts();
        if (accounts.length > 0) {
        instance.setActiveAccount(accounts[0]);
        }
    const handleLogout =()=>{
      const authProvider = getAuthProvider();
      localStorage.clear();
      authProvider.logout();
        //     await instance.handleRedirectPromise(); 
        //     if(accounts.length === 0){
        //         await instance.loginPopup({
        //         scopes:getAppConfiguration().scopes
        //       })
        //    }
    }
  
     const { formatMessage } = useIntl();
    const handleLogIn =async()=>{
        
         await instance.handleRedirectPromise();
        if(accounts.length === 0){
             await instance.loginRedirect({
             scopes:getAppConfiguration().scopes
           })
        }
    }
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
    };
  
    const handleClose = () => {
      setAnchorEl(null);
    };
    return (
        <>
        <Hidden only="xs">
        {/* Desktop */}
        <Button onClick={handleLogout} className={classes.root}>
          <FormattedMessage id="component.sidebar.logout" defaultMessage="Log out" description="Label for Logout-button" />
        </Button>
      </Hidden>
      <Hidden smUp>
        {/* Tablet & Mobile */}
        <div className={classes.menu}>
          <IconButton
            className={classes.iconButton}
            onClick={handleClick}
            aria-controls="simple-menu"
            aria-haspopup="true"
          >
            <AccountCircle />
          </IconButton>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
            getContentAnchorEl={null} //Needed because of: https://github.com/mui-org/material-ui/issues/7961
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <MenuItem onClick={handleLogout}>
              <FormattedMessage id="component.sidebar.logout" defaultMessage="Log out" description="Label for Logout-button" />
            </MenuItem>
          </Menu>
        </div>
      </Hidden>
        </>
    )
}